import React from 'react';

interface TrendUpIconProps {
  className?: string;
}

const TrendUpIcon: React.FC<TrendUpIconProps> = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 14L14 5M14 5H7M14 5V12"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrendUpIcon;
